/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { usePlayer } from "@packages/media";
import { ModalTab, MusicIcon } from "@packages/ui";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectBackgroundTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const player = usePlayer();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTab
      key={"selectBgMenuTab"}
      value={"selectBgMenu"}
      label={t("track_settings_background_sounds")}
      startIcon={<MusicIcon />}
      disabled={disabled}
      onClick={() =>
        track({
          event: HallowAnalyticsEvent.TappedBackgroundMusic,
          properties: analyticsProps,
        })
      }
    >
      {player?.bgTitle ?? t("web_audio_setting_list_option_background_none")}
    </ModalTab>
  );
};
